import { axiosWdw, domainEndpoint } from '@/api/axios';
// import { useToast } from "primevue/usetoast";
import qs from 'qs';

export default {
  login(email: string, password: string, domainid: number) {
    const data = {
      email: email,
      password: password,
      domainid: domainid,
      device: 'wdw-vue-widget',
    };
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'POST',
        url: 'login',
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
        },
        data: qs.stringify(data),
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  logout() {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: 'logout',
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  activateUser(token: string) {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + '/activate_user',
        params: { token: token },
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  renewActivation(email: string) {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + '/renew_activation',
        params: { email: email },
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  requestPassword(email: string) {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + '/request_password',
        params: { email: email },
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  sendPassword(userid: string, token: string) {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + '/send_password',
        params: { userid: userid, token: token },
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getVirtualUser() {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + '/get_guest_user',
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
